import * as React from "react"
import {SelectSeeker} from "@ui-seeker/core";

import { deviceType } from "@signals"
import {DEVICE_TYPE} from "@constants";

const OPTIONS = [
    { label: "Mobile", value: DEVICE_TYPE.MOBILE },
    { label: "App", value: DEVICE_TYPE.APP }
]

export default function DIPDeviceTypeSelect({ ...props }) {
    return <SelectSeeker
        isClearable
        options={OPTIONS}
        label="Device"
        placeholder="All Devices"
        value={deviceType.value}
        onChange={e => deviceType.value = e.target.value}
        {...props}
    />
}